module.exports = __webpack_public_path__ + "static/media/ic_check.9d3ec50f.svg";